import React from 'react';
import SearchDropDownComponent from '../../../DropDown/SearchDropDown/SearchDropDown';
import { Title, ReasonContainer } from './DTSelectReason.styles';
import { reasonTypesReadableMap } from 'constants/decisionTree';

const DTSelectReason = ({ selectedReason, reasonsList, changeHandler, type }) => {
  return (
    <ReasonContainer>
      <Title>Select a reason for the {reasonTypesReadableMap[type]}</Title>
      <SearchDropDownComponent
        selectedId={selectedReason}
        placeholder="Select a reason"
        options={reasonsList}
        onChange={changeHandler}
      />
    </ReasonContainer>
  );
};

export default DTSelectReason;
